<template>
  <RevCardCarousel
    v-if="articles && articles.length"
    :next-alternative-text="i18n(translations.nextSlideText)"
    :prev-alternative-text="i18n(translations.prevSlideText)"
    :title="i18n(translations.title)"
  >
    <ArticleCard
      v-for="article in articles"
      :key="article.id"
      data-test="article-card"
      v-bind="article"
    />
  </RevCardCarousel>
</template>

<script setup lang="ts">
import ArticleCard from '@backmarket/nuxt-layer-cms/ArticleCard/ArticleCard.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCardCarousel } from '@ds/components/CardCarousel'

import translations from './Articles.translations'
import { useArticles } from './composables/useArticles'

const i18n = useI18n()

const { sourceUrl } = defineProps<{ sourceUrl: string }>()

const { data: articles } = await useArticles(sourceUrl)
</script>
